import React, { useEffect, useRef,useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { NavLink, useHistory } from 'react-router-dom';
import { isLogin, getPrivileges } from '../../functions/Auth';

const useStyles = makeStyles((theme) => ({}))

const DetailsOptions = props => {
    //details options
    const [anchorElDetailsMenu, setanchorElDetailsMenu] = React.useState(null);
    const openDetailsMenu = Boolean(anchorElDetailsMenu);
    const handleClickDetailsMenu = (event) => {
        setanchorElDetailsMenu(event.currentTarget);
    };
    const handleCloseDetailsMenu = () => {
        setanchorElDetailsMenu(null);
    }  
    const handleViewAllDetails = () =>{
        handleCloseDetailsMenu();
        if(props.modal != undefined){
            props.modal();
        }
    }

    const handleExportData = () => {
      handleCloseDetailsMenu();
      props.setExportData();
    }

    const handeEditEstation = (stationData) =>{
      handleCloseDetailsMenu();
      props.handleStationDetails(stationData.station_id,stationData.status)
    } 
    //end details options
    return props.isOnlyExport?(<React.Fragment>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls="long-menu"
        aria-expanded={openDetailsMenu ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClickDetailsMenu}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu                        
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
          'class':'menu-details-pnl'
        }}
        anchorEl={anchorElDetailsMenu}
        open={openDetailsMenu}
        onClose={handleCloseDetailsMenu}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            maxWidth: '192px',
            padding:'0px',
            background: '#FFFFFF',
            borderRadius: '6px',
            boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)'
          },
        }}
      >
          <MenuItem key={2}  onClick={handleExportData} className={!props.hasData && "menu-opt-disabled"}>
          <img src={require('../../assets/icons/st_details_export.svg')}  /> Export
          </MenuItem>
    </Menu>
  </React.Fragment>):(
        <React.Fragment>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls="long-menu"
              aria-expanded={openDetailsMenu ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClickDetailsMenu}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu                        
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button',
                'class':'menu-details-pnl'
              }}
              anchorEl={anchorElDetailsMenu}
              open={openDetailsMenu}
              onClose={handleCloseDetailsMenu}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  maxWidth: '192px',
                  padding:'0px',
                  background: '#FFFFFF',
                  borderRadius: '6px',
                  boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)'
                },
              }}
            >
              <MenuItem key={0} onClick={handleViewAllDetails}>
              <img src={require('../../assets/icons/st_details_view_all_details.svg')}  /> View all details
              </MenuItem>
              <MenuItem className="divider"></MenuItem>
              {getPrivileges().length === 1 && getPrivileges().includes(3) ?null :
                getPrivileges().length !== 0 ?
                 (props.stationData && !props.stationData.is_shared) ?
                  <> 
                  <MenuItem key={1} onClick={handleCloseDetailsMenu}>
                  <NavLink to={`/UsersDashboard?import=${1}&station=${props.stationData?.client_station_id}`} style={{ textDecoration: 'none' }}>
                    <img src={require('../../assets/icons/st_details_import.svg')}  /> Import
                    </NavLink>                          
                  </MenuItem>
                  <MenuItem className="divider"></MenuItem> 
                  </>
                  :null
                :null}
                <MenuItem key={2}  onClick={handleExportData} className={!props.hasData && "menu-opt-disabled"}>
                <img src={require('../../assets/icons/st_details_export.svg')}  /> Export
                </MenuItem>
                <MenuItem className="divider"></MenuItem>
                {getPrivileges().includes(1) ?(props.stationData && !props.stationData.is_shared) ?<MenuItem key={3} onClick={()=>handeEditEstation(props.stationData)}>
                <img src={require('../../assets/icons/st_details_edit_station.svg')}  /> Edit station details
                </MenuItem>:null:null}
          </Menu>

        </React.Fragment>
    )
}

export default DetailsOptions;